<template>
  <div class="left_block all-users profile">
    <UserInfo
      @photo="openPhotoModal"
      @open-modal="openCourseAddModal"
      @delete="deleteUser"
      @edit="openEditModal"
      :profile-info="userInfo"
    />

    <p class="actions_header" v-if="userInfo.roles[0].name === 'user'">
      <span class="left">Назначенные курсы</span>
      <button class="right" @click="deleteChecked" :disabled="!rows.checked.length">
        <i class="mdi mdi-file-document-box-remove-outline"></i> Убрать курс из списка (отмеченные)
      </button>
    </p>

    <UserTable
      :is-loading="isLoading"
      @delete="deleteCourse"
      @click="openCourseInfo"
      :rows="rows"
      :user-courses="userCourses"
      v-if="userInfo.roles[0].name === 'user'"
    />

    <b-modal @close="closeCourseAddModal" :active.sync="courseAddModal" has-modal-card scroll="keep">
      <CourseAdd
        :modal-info="modal"
        @assign="assignChecked"
        :checked-courses="CheckedCourses"
        :categories-list="categoriesList"
        :user-courses="userCourses"
        @close-modal="closeCourseAddModal"
      />
    </b-modal>

    <b-modal @close="closeEditModal" :active.sync="editModal" has-modal-card scroll="keep">
      <EditModal
        :modal-info="modalInfo"
        :new-profile="newProfile"
        @click="updateProfile"
        @close-modal="closeEditModal"
      />
    </b-modal>

    <b-modal @close="closePhotoModal" :active.sync="editPhoto" has-modal-card scroll="keep">
      <EditPhoto @save="changePhoto" @close-modal="closePhotoModal" />
    </b-modal>
  </div>
</template>

<script>
import EditPhoto from '@/components/user/profile/EditPhoto'
import EditModal from '@/components/user/profile/EditModal'
import UserTable from '@/components/admin/users/UserTable'
import CourseAdd from '@/components/admin/users/CourseAdd'
import UserInfo from '@/components/user/profile/UserInfo'
import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    UserInfo,
    UserTable,
    CourseAdd,
    EditModal,
    EditPhoto
  },
  data() {
    return {
      modalInfo: {
        profileModal: false
      },
      editModal: false,
      courseAddModal: false,
      isLoading: true,
      newProfile: {
        name: '',
        surname: '',
        patronymic: '',
        branch_id: 0,
        position: ''
      },
      CheckedCourses: {
        ids: []
      },
      rows: {
        checked: []
      },
      modal: {
        date_start: new Date()
      },
      editPhoto: false,
      branchCategoriesList: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$axios2
        .get('users/' + this.userId)
        .then((resp) => {
          this.$store.commit('setUserInfo', { list: resp.data })
          let coursesList = []
          resp.data.user_course_data.forEach((user_course) => {
            const currentCourse = resp.data.courses.find((el) => el.id === user_course.course_id)
            const currentCategory = this.modalCategoriesList.find((el) => el.id === currentCourse.category_id)
            coursesList.push({
              date_start: user_course.date_start,
              name: currentCourse.name,
              id: currentCourse.id,
              days_limit: currentCourse.days_limit,
              status: user_course.status,
              category: {
                name: currentCategory ? currentCategory.name : '-'
              }
            })
          })
          this.$store.commit('setUserCourses', { list: coursesList })
          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    },
    deleteUser() {
      this.$axios2
        .delete('users/' + this.userId)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.$router.push('/all-users')
        })
        .catch(this.$errorToast)
    },
    openEditModal() {
      this.newProfile = {
        name: '',
        surname: '',
        branch_id: this.userInfo.branch_id,
        position: ''
      }
      this.editModal = true
    },
    closeEditModal() {
      this.editModal = false
    },
     openCourseAddModal() {
      this.modal.date_start = new Date()
      this.$axios2
        .get('categories/')
        .then((resp) => {
          this.$store.commit('setCategoriesList', { list: resp.data })
          this.courseAddModal = true
        })
       .catch(this.$errorToast)
    },
     getCoursesList() {
      this.$axios2
        .get('/courses/list?category')
        .then((resp) => {
          this.$store.commit('setCoursesList', { list: resp.data })
        })
       .catch(this.$errorToast)
    },
    closeCourseAddModal() {
      this.courseAddModal = false
      this.CheckedCourses.ids = []
    },
    openCourseInfo(course) {
      this.$router.push('/all-courses/course-statistic/' + course.id)
    },
    assignChecked() {
      this.$axios2
        .post('users/' + this.userId + '/courses/attach', {
          date_start: this.$moment(this.modal.date_start).format('YYYY-MM-DD'),
          course_ids: this.CheckedCourses.ids
        })
        .then(() => {
          this.closeCourseAddModal()
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    deleteCourse(courseID) {
      this.$axios2
        .post('users/' + this.userId + '/courses/detach', {
          course_ids: typeof courseID === 'number' ? [courseID] : courseID
        })
        .then(() => {
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    deleteChecked() {
      let course_ids = []
      this.rows.checked.forEach((course) => {
        course_ids.push(course.id)
      })
      this.deleteCourse(course_ids)
      this.rows.checked = []
    },
    updateProfile() {
      let request = {
        id: this.userId
      }
      Object.keys(this.newProfile).forEach((key) => {
        if (this.newProfile[key]) {
          request[key] = this.newProfile[key]
        }
      })
      this.$axios2
        .post('users/' + request.id, request)
        .then(() => {
          this.closeEditModal()
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    changePhoto(file) {
      const fData = new FormData()
      fData.append('id', this.userId)
      fData.append('image', file)
      this.$axios2
        .post('users/' + this.userId, fData, { headers: { 'content-type': 'multipart/form-data' } })
        .then(() => {
          this.closePhotoModal()
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    closePhotoModal() {
      this.editPhoto = false
    },
    openPhotoModal() {
      this.editPhoto = true
    },

  },
  computed: {
    userInfo() {
      return this.$store.state.allUsers.UserInfo
    },
    userCourses() {
      return this.$store.state.allUsers.userCourses
    },
    userId() {
      return this.$route.params.id
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    },
    modalCategoriesList() {
      return this.$store.state.categories.ModalCategoriesList
    }
  }
}
</script>
